import React from 'react';
import { IconContainer, ExternalLink } from '@icons/common';
import { Button } from '@components/Button';
import { SignInLinkInformation } from '@layouts/Header/Header.types';
import dataLayer from '@helpers/dataLayer';
import './SignInDropdown.scss';
import { productShopUrl } from '@helpers/consts';

interface SignInDropdownProps {
  signInInformation?: string;
  links?: SignInLinkInformation[];
}

export const SignInDropdown = ({ signInInformation, links }: SignInDropdownProps) => {

  const handleDatalayerPush = (linkText: string, linkUrl: string) => {
    dataLayer.push('exit_link', {
      link_text: linkText,
      link_url: linkUrl,
    });
  }
  return (
    <>
      <div className='sign-in-header' dangerouslySetInnerHTML={{ __html: signInInformation }}></div>
      <div className='sign-in-button-container'>
        {links.map((item, index) => (
          <Button
            onClick={() => handleDatalayerPush(item.Text, item.Url)}
            key={index}
            className='c-sign-in-dropdown-button'
            text={item.Text}
            size='small'
            color='primary'
            href={item.Url}
            //Story 365068 - Added new attribute i.e referrerpolicy="unsafe-url" if item.Url contains shop.alfalaval.com
            {...(item.Url?.includes(productShopUrl) && { referrerPolicy: 'unsafe-url' })}
          >
            <IconContainer key={index} icon={<ExternalLink />} className='svg-icon icon-sign-in' />
          </Button>
        ))}
      </div>
    </>
  );
};
